/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FilterEstateTags } from '../models/FilterEstateTags';
import type { TagModel } from '../models/TagModel';
import type { VitecIncreasedRequirement } from '../models/VitecIncreasedRequirement';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SearchService {

    /**
     * @param freetext
     * @returns FilterEstateTags Success
     * @throws ApiError
     */
    public static searchAutoComplete(
        freetext?: string,
    ): CancelablePromise<FilterEstateTags> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Search/AutoComplete',
            query: {
                'freetext': freetext,
            },
        });
    }

    /**
     * @returns VitecIncreasedRequirement Success
     * @throws ApiError
     */
    public static searchLoadExtraSearchCriteria(): CancelablePromise<Array<VitecIncreasedRequirement>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Search/LoadExtraSearchCriteria',
        });
    }

    /**
     * @param brokerId
     * @returns TagModel Success
     * @throws ApiError
     */
    public static searchGetBrokerTag(
        brokerId?: string,
    ): CancelablePromise<TagModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Search/GetBrokerTag',
            query: {
                'brokerId': brokerId,
            },
        });
    }

    /**
     * @param customerId
     * @returns TagModel Success
     * @throws ApiError
     */
    public static searchGetOfficeTag(
        customerId?: string,
    ): CancelablePromise<TagModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Search/GetOfficeTag',
            query: {
                'customerId': customerId,
            },
        });
    }

    /**
     * @param municipality
     * @returns TagModel Success
     * @throws ApiError
     */
    public static searchCreateMunicipalityTags(
        municipality?: string,
    ): CancelablePromise<TagModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Search/CreateMunicipalityTags',
            query: {
                'municipality': municipality,
            },
        });
    }

    /**
     * @param county
     * @returns TagModel Success
     * @throws ApiError
     */
    public static searchCreateCountyTags(
        county?: string,
    ): CancelablePromise<TagModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Search/CreateCountyTags',
            query: {
                'county': county,
            },
        });
    }

}
